<template>
  <div class="wp-chips">
    <div class="wp-chips__field">
      <ul class="wp-chips__list list-unstyled">
        <li
          v-for="val in items"
          :key="val"
        >
          {{ val }} <span @click="remove(val)">x</span>
        </li>
        <input
          v-model="newItem"
          type="text"
          :list="randomId"
          @keydown.enter.prevent="add"
        >
        <datalist :id="randomId">
          <option
            v-for="option in options"
            :key="option"
          >
            {{ option }}
          </option>
        </datalist>
        <span
          class="wp-chips__add"
          @click.prevent="add"
        >
          Toevoegen
        </span>
      </ul>
      <input
        type="hidden"
        :name="name"
        :value="joinedItems"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'WpChips',
  props: {
    value: {
      type: String,
      default: '[]',
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      newItem: '',
      items: this.value[0] === '[' ? JSON.parse(this.value) : this.value.split(', '),
    };
  },
  computed: {
    joinedItems() {
      return JSON.stringify(this.items);
    },
    randomId() {
      return `autocomplete-${this.randomNum()}${this.randomNum()}`;
    },
  },
  methods: {
    add() {
      if (this.newItem === '') return;
      this.items.push(this.newItem);
      this.newItem = '';
      this.$emit('input', this.joinedItems);
    },
    remove(value) {
      this.items = this.items.filter(e => e !== value);
      this.$emit('input', this.joinedItems);
    },
    randomNum() {
      return Math.random().toString().replace('0.', '');
    },
  },
};
</script>

<style lang="scss">
.wp-chips {
  font-size: 14px;
  border: none;
  border-radius: none;
  -webkit-box-shadow: none;
  box-shadow: none;

  &__field {
    display: flex;
  }

  &__name {
    min-width: 160px;;
    padding-top: 3px;
    text-align: end;
    width: 160px;
  }

  &__required {
    text-decoration: underline;
    text-decoration-style: dotted;
  }

  &__list {
    align-items: flex-start;
    display: flex;
    flex-flow: row wrap;

    li {
      background: #e6e6e6;
      margin: 4px 10px 4px 0;
      padding: 5px 8px;

      span {
        color: #a6a6a6;
        cursor: pointer;
        font-size: 12px;
        margin-left: 7px;
      }
    }

    input {
      margin-top: 4px;
    }
  }

  &__add {
    color: $color-kiwa-aqua;
    cursor: pointer;
    line-height: 30px;
    margin-left: 10px;
    vertical-align: center;
  }
}
</style>
